import './index.scss';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Windmill } from '@windmill/react-ui';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import App from './App';
import vidTheme from './style/VidTheme';
import { runServiceWorkerKillSwitch } from './swKillSwitch';

void (async () => {
  // Drain any lingering CRA service worker before mounting React; if a stale
  // SW is found this triggers a one-time reload and we never reach the mount.
  // Failures here must not block the app for healthy clients.
  try {
    await runServiceWorkerKillSwitch();
  } catch {
    // swallowed by design — bonus rescue behavior, never breaks the happy path
  }

  const container = document.getElementById('root');
  if (container) {
    const root = createRoot(container);
    root.render(
      <Windmill theme={vidTheme}>
        <React.StrictMode>
          <App />
        </React.StrictMode>
      </Windmill>,
    );
  }

  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://cra.link/PWA
  serviceWorkerRegistration.unregister();

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
})();
